export const ru = {
    cancel: 'Отмена',
    save: 'Сохранить все форматы',
    sidebarTitle: 'Размеры',
    subtitle: 'Теперь можно выбрать центр изображения вручную для каждого формата.',
    title: 'Позиционирование изображения'
};
